import {
  SIGN_AGREEMENT,
  GET_AGREEMENT_INFO,
  CLEAN_AGREEMENT_INFO
} from 'actions/types';

const signAgreement = (action, state) => {
  const { payload } = action;
  const { status } = payload;

  if (status === 201) {
    return { ...state, agreementAccepted: true };
  }

  return state;
};

const getAgreementInfo = (action, state) => {
  const { payload } = action;
  const { status, data } = payload;

  if (status === 200 && data.data) {
    return { ...state, ...data.data };
  }

  return state;
};

export default function(state = null, action) {
  switch (action.type) {
    case SIGN_AGREEMENT:
      return signAgreement(action, state);
    case GET_AGREEMENT_INFO:
      return getAgreementInfo(action, state);
    case CLEAN_AGREEMENT_INFO:
      return null;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/agreement.js